// Configure your insurance product variant ID (just the numeric part)
const INSURANCE_VARIANT_ID_NUMERIC = '47823350268130';
const INSURANCE_VARIANT_ID_FULL = 'gid://shopify/ProductVariant/47823350268130';
const API_URL = 'https://btg-insurance.vercel.app';

let cartCache = null;
let cartCacheTimestamp = 0;
let insuranceAddInProgress = false;

async function getCachedCartGID() {
  const now = Date.now();
  if (cartCache && now - cartCacheTimestamp < 300) return cartCache; // was 2000ms
  cartCache = await getCartGID();
  cartCacheTimestamp = now;
  return cartCache;
}

// Utility to get cart GID
async function getCartGID() {
  try {
    const cartResponse = await fetch('/cart.json');
    const cartData = await cartResponse.json();
    
    if (!cartData || !cartData.token) {
      console.error('No cart token found');
      return null;
    }
    
    const tokenWithKey = cartData.token;
    const fullCartId = `gid://shopify/Cart/${tokenWithKey}`;
    
    return {
      cartId: fullCartId,
      itemCount: cartData.item_count,
      items: cartData.items,
      cartData: cartData
    };
  } catch (error) {
    console.error('Error getting cart GID:', error);
    return null;
  }
}

// Enhanced cart refresh using section rendering
async function refreshCartDrawer() {  
  const productList = document.querySelector('ul.wt-cart__list');
  if (!productList) return;
  const firstItem = productList.querySelector('li');
  if (!firstItem) return;
  const quantityCounter = firstItem.querySelector('quantity-counter');
  if (!quantityCounter) return;
  const counterQuanitity = firstItem.querySelector('input.other-items');
  if (!counterQuanitity) return;
  quantityCounter.updateValue(parseInt(counterQuanitity.value)); 
  const insuranceItem = productList.querySelector('input.insurance-quantity')
  console.log("insuranceItem", insuranceItem)
  if(insuranceItem?.value){
    let insuranceQuanitity = parseInt(insuranceItem.value);
    if(insuranceQuanitity > 1){
      quantityCounter.updateValue(1);  
    }
  }       
}

async function refreshThemeCartDrawer() {
  const cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl && typeof cartDrawerEl.refreshCartDrawer === 'function') {
    await cartDrawerEl.refreshCartDrawer();
  } else {
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
    await new Promise(r => setTimeout(r, 400)); // no promise to await on this path
  }
}

async function syncQuantityCounterAfterInsurance(retries = 5) {
  const productList = document.querySelector('ul.wt-cart__list');
  const insuranceItem = productList?.querySelector('input.insurance-quantity');

  if (!insuranceItem) {
    if (retries > 0) {
      await new Promise(r => setTimeout(r, 150));
      return syncQuantityCounterAfterInsurance(retries - 1);
    }
    console.warn('insurance-quantity input not found after retries — insurance line item may not have rendered');
    return;
  }

  const firstItem = productList.querySelector('li');
  const quantityCounter = firstItem?.querySelector('quantity-counter');
  const counterQuantity = firstItem?.querySelector('input.other-items');
  if (!quantityCounter || !counterQuantity) return;

  quantityCounter.updateValue(parseInt(counterQuantity.value, 10));

  const insuranceQuantity = parseInt(insuranceItem.value, 10);
  if (insuranceQuantity > 1) {
    quantityCounter.updateValue(1);
  }
}

// Add insurance via your API
async function addInsuranceViaAPI() {
  try {
    const cartInfo = await getCachedCartGID();

    if (!cartInfo || !cartInfo.cartId) {
      console.error('Could not get cart ID');
      return { ok: false, alreadyInCart: false };
    }

    const hasInsurance = cartInfo.items.some(item =>
      item.variant_id.toString() === INSURANCE_VARIANT_ID_NUMERIC
    );

    if (hasInsurance) {
      console.log('Insurance already in cart');
      return { ok: true, alreadyInCart: true }; // success: nothing to do
    }

    const response = await fetch(`${API_URL}/add-to-cart`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        cartId: cartInfo.cartId,
        variantId: INSURANCE_VARIANT_ID_FULL,
        quantity: 1
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to add insurance');
    }

    await response.json();
    return { ok: true, alreadyInCart: false };
  } catch (error) {
    console.error('Error adding insurance via API:', error);
    return { ok: false, alreadyInCart: false };
  }
}

// Add insurance directly via Shopify Cart API (fallback method)
async function addInsuranceViaShopify() {
  try {
    console.log('Adding insurance via Shopify Cart API...');

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: INSURANCE_VARIANT_ID_NUMERIC, quantity: 1 }]
      })
    });

    if (!response.ok) throw new Error('Failed to add insurance via Shopify API');

    const result = await response.json();
    console.log('Insurance added successfully via Shopify:', result);
    return true;
  } catch (error) {
    console.error('Error adding insurance via Shopify:', error);
    return false;
  }
}

// Main function to add insurance and refresh cart
async function addInsuranceToCart() {
  if (insuranceAddInProgress) {
    console.log('Insurance add already in progress, skipping duplicate call');
    return false;
  }
  insuranceAddInProgress = true;

  try {
    const apiResult = await addInsuranceViaAPI();

    // Already there — do nothing, and definitely don't fall back.
    if (apiResult.alreadyInCart) return true;

    if (!apiResult.ok) {
      // Before falling back, re-check against the LIVE cart (not the 2s
      // cache) in case the API actually succeeded and only the response
      // parsing failed.
      const freshCart = await fetch('/cart.js').then(r => r.json());
      const alreadyThere = freshCart.items.some(item =>
        item.variant_id.toString() === INSURANCE_VARIANT_ID_NUMERIC
      );
      if (alreadyThere) {
        await refreshCartDrawer();
        return true;
      }

      const shopifySuccess = await addInsuranceViaShopify();
      if (!shopifySuccess) {
        console.error('Failed to add insurance via both methods');
        return false;
      }
    }

    await new Promise(resolve => setTimeout(resolve, 500));
    // await refreshCartDrawer();
    await refreshThemeCartDrawer();  
    await syncQuantityCounterAfterInsurance(); 
    return true;
  } catch (error) {
    console.error('Error in addInsuranceToCart:', error);
    return false;
  } finally {
    insuranceAddInProgress = false;
  }
}

async function checkInsurance() {
  try {
    const cartInfo = await getCachedCartGID();

    if (!cartInfo || !cartInfo.items) {
      console.warn('Cart not available');
      return false;
    }

    const hasInsurance = cartInfo.items.some(item =>
      item.variant_id.toString() === INSURANCE_VARIANT_ID_NUMERIC
    );

    return hasInsurance;
  } catch (error) {
    console.error('Error checking insurance:', error);
    return false;
  }
}

// Check and add insurance if needed
async function checkAndAddInsurance() {
  const cartInfo = await getCachedCartGID();
  
  if (!cartInfo || cartInfo.itemCount === 0) {
    return;
  }
  
  // Check if insurance is already in cart
  const hasInsurance = cartInfo.items.some(item => 
    item.variant_id.toString() === INSURANCE_VARIANT_ID_NUMERIC
  );
  
  if (!hasInsurance) {
    console.log('Cart needs insurance, adding...');
    await addInsuranceToCart();
  }
}

// Wait for cart operations to complete
function waitForCartOperation() {
  return new Promise(resolve => setTimeout(resolve, 1000));
}

function removeInsuranceIfAlone() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const items = cart.items;
        const onlyInsurance = items.length === 1 && items[0].id === INSURANCE_ID;

        if (onlyInsurance) {
          const removeBtn = document.getElementById('remove-' + INSURANCE_ID);
          if (removeBtn) {
            removeBtn.click();
          }
        }
      });
  }


  // Initialize

document.addEventListener('DOMContentLoaded', function() {
  // Auto-add disabled — insurance now only added via manual button click
  // setTimeout(() => {
  //   checkAndAddInsurance();
  // }, 500);
});

// Event delegation - works even if button is added/re-rendered later
document.addEventListener('click', function(event) {
  const btn = event.target.closest('#add-insurance-btn');
  if (btn) {
    window.insuranceIntegration.addInsurance();
  }
});

// Listen for cart drawer opening
// const observeCartDrawer = () => {
//   const cartDrawer = document.querySelector('cart-drawer');
  
//   if (cartDrawer) {
//     const observer = new MutationObserver((mutations) => {
//       mutations.forEach((mutation) => {
//         if (mutation.attributeName === 'class') {
//           const isOpen = cartDrawer.classList.contains('active') || 
//                         cartDrawer.classList.contains('open');
          
//           if (isOpen) {
//             console.log('Cart drawer opened');
//             setTimeout(() => {
//               checkAndAddInsurance();
//             }, 300);
//           }
//         }
//       });
//     });
    
//     observer.observe(cartDrawer, { attributes: true });
//   }
// };

// Run observer after DOM is ready
// setTimeout(observeCartDrawer, 1000);

// Intercept fetch requests to /cart/add.js
// const originalFetch = window.fetch;
// window.fetch = function(...args) {
//   const [url, options] = args;
  
//   // Check if this is a cart add request
//   if (url && url.includes('/cart/add')) {
//     console.log('Cart add request intercepted');
    
//     // Call original fetch
//     return originalFetch.apply(this, args)
//       .then(async (response) => {
//         // Clone response before reading
//         const clonedResponse = response.clone();
        
//         // Wait for operation to complete
//         await waitForCartOperation();
        
//         // Check and add insurance
//         await checkAndAddInsurance();
        
//         return clonedResponse;
//       });
//   }
  
//   return originalFetch.apply(this, args);
// };

// Listen for theme-specific events
// document.addEventListener('cart:updated', async function() {
//   console.log('cart:updated event detected');
//   await waitForCartOperation();
//   await checkAndAddInsurance();
// });

// document.addEventListener('cart.requestComplete', async function() {
//   console.log('cart.requestComplete event detected');
//   await waitForCartOperation();
//   await checkAndAddInsurance();
// });

// Export for external use
window.insuranceIntegration = {
  addInsurance: addInsuranceToCart,
  checkAndAdd: checkAndAddInsurance,
  checkInsurance: checkInsurance,
  refreshCart: refreshCartDrawer,
  addViaAPI: addInsuranceViaAPI,
  addViaShopify: addInsuranceViaShopify,
  removeInsuranceIfAlone: removeInsuranceIfAlone
};

console.log('Insurance integration loaded. Use window.insuranceIntegration to access functions.');